import _ from 'lodash';

const resetElectronicPaymentData = (submissionVM, updateWizardData) => {
    const epayData = _.get(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA');

    if (epayData && epayData.aspects && !epayData.aspects.subtreeValid) {
        // eslint-disable-next-line no-secrets/no-secrets
        _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', null);
        updateWizardData(submissionVM);
    }
};

export {
    resetElectronicPaymentData
};
